<template>
    <div id="options-change-email">
        <h3>Cambiar Correo electrónico</h3>
        <b-alert show variant="info">
            Se le recomienda usar un correo electrónico de Gmail ya que actualmente el
            servidor de correos de la facultad (@ciens.ucv.ve) presenta dificultades con
            otros servicios como Hotmail/Outlook.
        </b-alert>

        <b-form
            @submit.stop.prevent="onSubmit"
            class="mt-4"
        >
            <b-row>
                <b-col
                    cols="12"
                    lg="6"
                >
                    <b-form-group
                        id="input-group-email"
                        label="*Nuevo correo:"
                        label-for="input-email"
                    >
                        <b-form-input
                            id="input-email"
                            v-model="$v.form.email.$model"
                            type="email"
                            required
                            :disabled="formDisabled"
                            :state="validateState('email')"
                        />
                        <b-form-invalid-feedback id="input-email-feedback">
                            Este campo es requerido y debe ser una dirección de correo válida.
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>

                <b-col
                    cols="12"
                    lg="6"
                >
                    <b-form-group
                        id="input-group-confirm-email"
                        label="*Repetir correo:"
                        label-for="input-confirm"
                    >
                        <b-form-input
                            id="input-confirm-email"
                            v-model="$v.form.confirmEmail.$model"
                            type="email"
                            required
                            :disabled="formDisabled"
                            :state="validateState('confirmEmail')"
                        />
                        <b-form-invalid-feedback id="input-confirm-email-feedback">
                            Este campo es requerido y debe ser igual al correo ingresado.
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <div class="text-center float-right">
                <b-button
                    type="submit"
                    variant="primary"
                    size="lg"
                    :disabled="formDisabled || $v.form.$invalid"
                >
                    Cambiar
                </b-button>
            </div>

        </b-form>

    </div>
</template>

<script>
import { required, email, sameAs } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
    name: 'SettingsChangeEmail',
    data () {
        return {
            formDisabled: false,
            form: {
                email: '',
                confirmEmail: ''
            }
        }
    },
    validations: {
        form: {
            email: {
                required,
                email
            },
            confirmEmail: {
                required,
                email,
                sameAs: sameAs('email')
            }
        }
    },
    methods: {
        ...mapActions([
            'changeCurrentUserEmail'
        ]),
        validateState (name) {
            const { $dirty, $error } = this.$v.form[name]
            return $dirty ? !$error : null
        },
        async onSubmit () {
            const newEmail = this.form.email

            try {
                this.formDisabled = true
                await this.changeCurrentUserEmail(newEmail)
                this.$root.successToast('Su correo electrónico ha sido cambiado satisfactoriamente.', 'Cambio de Correo Exitoso')
                this.form.email = ''
                this.form.confirmEmail = ''
                this.$v.$reset()
            } catch (err) {
                console.log(err)
                this.unknownErrorToast()
            } finally {
                this.formDisabled = false
            }
        }
    }
}
</script>
